import React, { useState, useEffect } from 'react';
import "../Admin/assete/css/viewcareer.css";
import Adminheader from './Adminheader';
import { ViewCareerDetailsApi, deleteCareerDetailsApi, updateCareerDetailsApi } from "../service/Api";
import Sidebar from './Siderbar';

const Viewcareer = () => {
  const [details, setDetails] = useState([]);
  // const [showAll, setShowAll] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editedData, setEditedData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ViewCareerDetailsApi();
        if (response && response.careersdetails) {
          setDetails(response.careersdetails.reverse());
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);



  const handleDelete = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete this career detail?");
    if (!confirmed) return;

    try {
      await deleteCareerDetailsApi(id);
      setDetails((prevDetails) => prevDetails.filter((detail) => detail.id !== id));
      //alert("Career detail deleted successfully!");
    } catch (error) {
      console.error("Error deleting career detail:", error);
      alert("Failed to delete the career detail. Please try again.");
    }
  };

  const handleEdit = (id, data) => {
    setEditId(id);
    setEditedData(data);
  };

  const handleInputChange = (field, value) => {
    setEditedData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleUpdate = async (id) => {
    try {
      await updateCareerDetailsApi(id, editedData);
      setDetails((prevDetails) =>
        prevDetails.map((detail) =>
          detail.id === id ? { ...detail, ...editedData } : detail
        )
      );
      alert("Career detail updated successfully!");
      setEditId(null);
    } catch (error) {
      console.error("Error updating career detail:", error);
      alert("Failed to update the career detail. Please try again.");
    }
  };

  // Group details into chunks of 3
  const chunkSize = 3;
  const groupedDetails = [];
  for (let i = 0; i < details.length; i += chunkSize) {
    groupedDetails.push(details.slice(i, i + chunkSize));
  }

  const unreadCount = details.filter(detail => detail.readed !== "read").length;

  return (
    <>
      <div className='body-div'>
        <Adminheader unreadCount={unreadCount} />
        <div className='container_dashboard'>
          <div className='index-content'>
            <Sidebar />
            <div className='dashboard_main_div'>
              <div className='dashboard_div_1'>
                <div className='care_const'>
                  <h2>View Career Details</h2>
                </div>
                {groupedDetails.map((group, groupIndex) => (
                  <div className='view_dtls_main_div' key={groupIndex}>
                    {group.map((detail, index) => (
                      <div className='view_dlts_div_1' key={index}>
                        <div className='view_div_min'>
                          <div className='view_dtls_card_div'>
                            <button onClick={() => handleDelete(detail.id)} className="delete_btn">x</button>
                            {editId === detail.id ? (
                              <>
                                <input
                                  value={editedData.job_name || ""}
                                  onChange={(e) => handleInputChange("job_name", e.target.value)}
                                  placeholder="Job Name"
                                />
                                <input
                                  value={editedData.Education || ""}
                                  onChange={(e) => handleInputChange("Education", e.target.value)}
                                  placeholder="Education"
                                />
                                <input
                                  value={editedData.Experience || ""}
                                  onChange={(e) => handleInputChange("Experience", e.target.value)}
                                  placeholder="Experience"
                                />
                                <input
                                  value={editedData.Location || ""}
                                  onChange={(e) => handleInputChange("Location", e.target.value)}
                                  placeholder="Location"
                                />

                                 <input
                                  value={editedData.Job_date || ""}
                                  onChange={(e) => handleInputChange("Job_date", e.target.value)}
                                  placeholder="Job opening date"
                                />

                                <textarea
                                  value={editedData.Job_Description || ""}
                                  onChange={(e) => handleInputChange("Job_Description", e.target.value)}
                                  placeholder="Job Description"
                                ></textarea>
                                <button onClick={() => handleUpdate(detail.id)}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 4C14.7486 4 17.1749 5.38626 18.6156 7.5H16V9.5H22V3.5H20V5.99936C18.1762 3.57166 15.2724 2 12 2C6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4ZM20 12C20 16.4183 16.4183 20 12 20C9.25144 20 6.82508 18.6137 5.38443 16.5H8V14.5H2V20.5H4V18.0006C5.82381 20.4283 8.72764 22 12 22C17.5228 22 22 17.5228 22 12H20Z"></path>
                                  </svg>
                                </button>
                                <button onClick={() => setEditId(null)}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z"></path>
                                  </svg>
                                </button>
                              </>
                            ) : (
                              <>
                                <h2><label>Job Name</label>: {detail.job_name}</h2>
                                <h2><label>Education</label>: {detail.Education}</h2>
                                <h2><label>Experience</label>: {detail.Experience}</h2>
                                <h2><label>Location</label>: {detail.Location}</h2>
                                <h2><label>Job opening date</label>: {detail.Job_date}</h2>
                                <h2 style={{ width: "100%", height: "150px", overflow: "scroll", backgroundColor: "#ffffff" }}><label>Job Description</label>: {detail.Job_Description}</h2>
                                <button onClick={() => handleEdit(detail.id, detail)} className='edit_btn'>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M15.7279 9.57627L14.3137 8.16206L5 17.4758V18.89H6.41421L15.7279 9.57627ZM17.1421 8.16206L18.5563 6.74785L17.1421 5.33363L15.7279 6.74785L17.1421 8.16206ZM7.24264 20.89H3V16.6473L16.435 3.21231C16.8256 2.82179 17.4587 2.82179 17.8492 3.21231L20.6777 6.04074C21.0682 6.43126 21.0682 7.06443 20.6777 7.45495L7.24264 20.89Z"></path>
                                  </svg>
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
                {/* {groupedDetails.length > 1 && (
                  <div className="show_more_div">
                    <button onClick={toggleShowAll} className="show_more_btn">
                      {showAll ? "Show Less" : "Show More"}
                    </button>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Viewcareer;